import { createContext, useContext } from "react";

export type ExpandedMenu = { menuId: string; pathname: string };

type SecondaryNavContextValue = {
  headerSlot: HTMLElement | null;
  bodySlot: HTMLElement | null;
  active: boolean;
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  registerActive: () => () => void;
  /** Sub-menu renders inline under its trigger (mobile nav), not in a separate column. */
  isInline?: boolean;
  expandedMenu?: ExpandedMenu | null;
  setExpandedMenu?: (menu: ExpandedMenu | null) => void;
};

export const SecondaryNavContext = createContext<SecondaryNavContextValue>({
  headerSlot: null,
  bodySlot: null,
  active: false,
  collapsed: false,
  setCollapsed: () => {},
  registerActive: () => () => {},
});

export const useSecondaryNav = (): SecondaryNavContextValue =>
  useContext(SecondaryNavContext);
